module.exports = __webpack_public_path__ + "img/Faltenglättung.2c7af1ed.svg";